/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChangeProNumberResult
 */
export interface ChangeProNumberResult {
  /**
   *
   * @type {boolean}
   * @memberof ChangeProNumberResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ChangeProNumberResult
   */
  errorMessage: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ChangeProNumberResult
   */
  existingShipmentIdlist?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof ChangeProNumberResult
   */
  trackingLinePublished: boolean;
}

/**
 * Check if a given object implements the ChangeProNumberResult interface.
 */
export function instanceOfChangeProNumberResult(
  value: object,
): value is ChangeProNumberResult {
  if (!("success" in value) || value["success"] === undefined) return false;
  if (!("errorMessage" in value) || value["errorMessage"] === undefined)
    return false;
  if (
    !("trackingLinePublished" in value) ||
    value["trackingLinePublished"] === undefined
  )
    return false;
  return true;
}

export function ChangeProNumberResultFromJSON(
  json: any,
): ChangeProNumberResult {
  return ChangeProNumberResultFromJSONTyped(json, false);
}

export function ChangeProNumberResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ChangeProNumberResult {
  if (json == null) {
    return json;
  }
  return {
    success: json["success"],
    errorMessage: json["errorMessage"],
    existingShipmentIdlist:
      json["existingShipmentIdlist"] == null
        ? undefined
        : json["existingShipmentIdlist"],
    trackingLinePublished: json["trackingLinePublished"],
  };
}

export function ChangeProNumberResultToJSON(json: any): ChangeProNumberResult {
  return ChangeProNumberResultToJSONTyped(json, false);
}

export function ChangeProNumberResultToJSONTyped(
  value?: ChangeProNumberResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    success: value["success"],
    errorMessage: value["errorMessage"],
    existingShipmentIdlist: value["existingShipmentIdlist"],
    trackingLinePublished: value["trackingLinePublished"],
  };
}
